import * as yup from 'yup';

import {
  basicBehaviorValidationSchema,
  metricsValidationSchema,
  autoscalerBehaviorValidationSchema,
} from 'features/cluster/workload-optimization/_woop-settings/_validations/hpa-v2';

import { HpaSettingsFormModel } from '../_types';

export const hpaV2ValidationSchema = yup.object({
  basicBehavior: basicBehaviorValidationSchema,
  metrics: metricsValidationSchema,
  autoscalerBehavior: autoscalerBehaviorValidationSchema,
}) satisfies yup.ObjectSchema<HpaSettingsFormModel>;
